module.exports = __webpack_public_path__ + "static/media/Towns Lecture Hall.66dd5936.png";